module.exports = __webpack_public_path__ + "static/NeutraText-Demi-0ab457451b75ef6ec0861ac9fcdd5e31.ttf";